import React from "react";
import ApexCharts from "react-apexcharts";
import { Grid, Paper } from "@mui/material";

const DepartmentVsProductChart = ({ data, onSliceClick }) => {
  // const options = {
  //   labels: data.labels,
  //   chart: {
  //     type: "donut",
  //     events: {
  //       dataPointSelection: (event, chartContext, { dataPointIndex }) => {
  //         onSliceClick(dataPointIndex);
  //       },
  //     },
  //   },
  // };

  // return <ApexCharts options={options} series={data.series} type="donut" height={400} />;
  return (
    <Grid item xs={6}>
      <Paper elevation={3} sx={{ padding: "20px", height: 450 }}>
        <ApexCharts
          options={{
            title: {
              text: "Department vs Product",
            },
            chart: {
              type: "donut",
              events: {
                dataPointSelection: (event, chartContext, { dataPointIndex }) => {
                  if (onSliceClick) {
                    onSliceClick(dataPointIndex); // Notify the parent about the clicked slice
                  }
                },
              },
            },
            tooltip: {
              text: "Displays the product distribution across departments."
            },
            labels: data.labels,
          }}
          series={data.series}
          type="donut"
          height={450}
        />
      </Paper>
    </Grid>
  );
};

export default DepartmentVsProductChart;
